import { Color } from '@lux/wardrobe-lib'
import { ActivityStep } from '../models/new-activity-creation-state'

export const getNewActivitySectionIcon = (section: Partial<ActivityStep>) => {
    return section.isDone ? 'status-ok' : section.isDirty ? 'status-warning' : null
}
export const getNewActivitySectionIconColor = (section: Partial<ActivityStep>) => {
    return section.isDone ? Color.SUCCESS : section.isDirty ? Color.ERROR : null
}
